<template>
  <v-card>
    <v-card-text class="d-flex" style="justify-content: space-between">
      <div style="width: 100%">
        <v-row>
          <v-col class="py-0" md="1">
            <v-text-field
              v-model="index"
              class="mb-1"
              label="優先度"
              readonly
            />
          </v-col>
          <v-col class="py-0" md="5">
            <v-text-field
              v-model="productLink.linkText"
              :rules="[presenceValidation]"
              class="mb-1"
              required
            >
              <template v-slot:label>
                <InputLabel label-name="リンク名" :required="true" />
              </template>
            </v-text-field>
          </v-col>
          <v-col class="py-0" md="6">
            <v-text-field
              v-model="productLink.url"
              :rules="[presenceValidation, urlValidation]"
              class="mb-1"
              required
            >
              <template v-slot:label>
                <InputLabel label-name="URL" :required="true" />
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" md="2">
            <v-select
              v-model="productLink.isTaxIncluded"
              class="mb-1"
              :items="taxIncludedSelectItems"
            >
              <template v-slot:label>
                <InputLabel label-name="税表示" :required="true" />
              </template>
            </v-select>
          </v-col>
          <v-col class="py-0" md="4">
            <v-text-field
              v-model="productLink.price"
              class="mb-1"
              type="number"
              prefix="¥"
              label="値段"
              required
            />
          </v-col>
          <v-col class="py-0" md="4">
            <v-autocomplete
              v-model="productLink.productLinkStyleId"
              :items="styleSelectOptions()"
              chips
              label="適用するリンクのスタイル"
              item-text="name"
              item-value="id"
            >
              <template v-slot:label>
                <InputLabel
                  label-name="適用するリンクのスタイル"
                  :required="true"
                />
              </template>
              <template v-slot:selection="data">
                <v-chip
                  :text-color="sampleFontColor()"
                  :style="{
                    'background-color': sampleBackgroundColor(),
                  }"
                >
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:append-item>
                <v-list-item-content class="px-1" @click="openLinkStyleModal">
                  <v-btn color="primary" outlined>リンクスタイルを作成</v-btn>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </div>
      <div
        class="d-flex pl-3"
        style="justify-content: space-between; flex-direction: column"
      >
        <v-icon class="p-linkForm__handle" size="40">mdi-menu</v-icon>
        <div>
          <v-btn
            color="red darken-1"
            outlined
            tile
            dark
            depressed
            @click.prevent.stop="deleteProductLink"
          >
            削除
          </v-btn>
        </div>
      </div>
    </v-card-text>
    <product-link-style-form
      :dialog="linkStyleDialog"
      @selected-product-link-style="addLinkStyle"
      @close-dialog="closeDialog"
    />
  </v-card>
</template>

<script>
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'
import ProductLinkStyleForm from './ProductLinkStyleForm'

export default {
  name: 'ProductLinkForm',
  components: { ProductLinkStyleForm, InputLabel },
  mixins: [formValidationUtils],
  props: {
    productLink: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    productLinkStyles: {
      type: Array
    }
  },
  data () {
    return {
      taxIncludedSelectItems: [
        { text: '税込', value: true },
        { text: '税抜', value: false }
      ],
      linkStyleDialog: false
    }
  },
  mounted () {
    this.productLink.priority = this.index
  },
  updated () {
    this.productLink.priority = this.index
  },
  methods: {
    deleteProductLink () {
      this.$emit('delete-product-link', this.productLink)
    },
    sampleBackgroundColor () {
      if (typeof this.productLink.productLinkStyleId !== 'number') return ''

      return this.productLinkStyles.find(
        (style) => style.id === this.productLink.productLinkStyleId
      ).backgroundColorCode
    },
    sampleFontColor () {
      if (typeof this.productLink.productLinkStyleId !== 'number') return ''

      return this.productLinkStyles.find(
        (style) => style.id === this.productLink.productLinkStyleId
      ).textColorCode
    },
    styleSelectOptions () {
      return [...(this.productLinkStyles || [])]
    },
    openLinkStyleModal () {
      this.linkStyleDialog = true
    },
    closeDialog () {
      this.linkStyleDialog = false
    },
    addLinkStyle (linkStyle) {
      this.productLinkStyles.push(linkStyle)
      this.$set(this.productLink, 'productLinkStyleId', linkStyle.id)
    }
  }
}
</script>

<style scoped>
.p-linkForm__handle:hover {
  cursor: grab;
  background-color: #eee;
}
</style>
